// extracted by mini-css-extract-plugin
export var impactTextAppear = "CharitableImpactText-module--impact-text-appear--jUuTs";
export var impactTextEnter = "CharitableImpactText-module--impact-text-enter--k6vdB";
export var impactTextAppearActive = "CharitableImpactText-module--impact-text-appear-active--HrJdA";
export var impactTextEnterActive = "CharitableImpactText-module--impact-text-enter-active--S+0AV";
export var impactTextExit = "CharitableImpactText-module--impact-text-exit--Ndsr9";
export var impactTextExitActive = "CharitableImpactText-module--impact-text-exit-active--Ij9HF";